export default __webpack_public_path__ + "static/media/PHÂN HỆ TIẾP ĐÓN.0ddaa83d.pdf";